import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["id", "className", "searchType", "defaultValue", "value", "placeholder", "searchValue", "onSearch", "disabled", "children", "ariaLabel", "valueKey", "labelKey", "categoryKey", "onSelect", "onChange", "data", "searchBy", "noResultFound", "noHistoryMsg", "onClose", "onOpen", "LocalStorageKey", "limitHistory", "showHistory", "onHistoryChange", "onKeyDown", "onFocus", "onBlur", "noList", "tabIndex", "onClear", "error", "inputProps"];
//@ts-nocheck
import * as React from 'react';
import { useCallback, useState, useEffect } from 'react';
import classNames from 'classnames';
import { useControlled, useClickOutside, KEY_VALUES, getActiveElement, getEventSource, mergeRefs } from '../utils';
import { transformData, shouldDisplay, useFocusItemValue, onMenuKeyDown } from './utils';
import { DropdownMenuItem } from '../select';
import { useLocalization } from '@appkit4/react-api';
var Search = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _items, _resultMessage;
  var id = props.id,
    className = props.className,
    _props$searchType = props.searchType,
    searchType = _props$searchType === void 0 ? 'primary' : _props$searchType,
    _props$defaultValue = props.defaultValue,
    defaultValue = _props$defaultValue === void 0 ? '' : _props$defaultValue,
    valueProp = props.value,
    placeholder = props.placeholder,
    searchValueProp = props.searchValue,
    onSearch = props.onSearch,
    disabled = props.disabled,
    children = props.children,
    ariaLabel = props.ariaLabel,
    _props$valueKey = props.valueKey,
    valueKey = _props$valueKey === void 0 ? 'value' : _props$valueKey,
    _props$labelKey = props.labelKey,
    labelKey = _props$labelKey === void 0 ? 'label' : _props$labelKey,
    _props$categoryKey = props.categoryKey,
    categoryKey = _props$categoryKey === void 0 ? 'category' : _props$categoryKey,
    onSelect = props.onSelect,
    onChange = props.onChange,
    _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    searchBy = props.searchBy,
    noResultFound = props.noResultFound,
    noHistoryMsg = props.noHistoryMsg,
    onClose = props.onClose,
    onOpen = props.onOpen,
    _props$LocalStorageKe = props.LocalStorageKey,
    LocalStorageKey = _props$LocalStorageKe === void 0 ? 'searchKeywords' : _props$LocalStorageKe,
    _props$limitHistory = props.limitHistory,
    limitHistory = _props$limitHistory === void 0 ? 10 : _props$limitHistory,
    _props$showHistory = props.showHistory,
    showHistoryProp = _props$showHistory === void 0 ? false : _props$showHistory,
    onHistoryChange = props.onHistoryChange,
    onKeyDown = props.onKeyDown,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    noList = props.noList,
    tabIndex = props.tabIndex,
    onClear = props.onClear,
    error = props.error,
    inputProps = props.inputProps,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  var items = [];
  var _useState = useState(''),
    value = _useState[0],
    setValue = _useState[1];
  var _useState2 = useState([]),
    nodes = _useState2[0],
    setNodes = _useState2[1];
  var _useControlled = useControlled(searchValueProp, defaultValue),
    searchValue = _useControlled[0],
    setSearchValue = _useControlled[1],
    isControlled = _useControlled[2];
  var _useState3 = useState(false),
    focus = _useState3[0],
    setFocus = _useState3[1];
  var _useState4 = useState(false),
    keyboardFocus = _useState4[0],
    setKeyboardFocus = _useState4[1];
  var _useState5 = useState(false),
    activeSearch = _useState5[0],
    setActiveSearch = _useState5[1];
  var _useState6 = useState(false),
    showPressIcon = _useState6[0],
    setShowPressIcon = _useState6[1];
  var _useState7 = useState(false),
    showDeleteIcon = _useState7[0],
    setShowDeleteIcon = _useState7[1];
  var _useState8 = useState(false),
    showList = _useState8[0],
    setShowList = _useState8[1];
  var _useState9 = useState(false),
    showBlank = _useState9[0],
    setShowBlank = _useState9[1];
  var _useState10 = useState(showHistoryProp),
    showHistory = _useState10[0],
    setShowHistory = _useState10[1];
  var nextFocusRef = React.useRef(null);
  var preFocusRef = React.useRef(null);
  var containerRef = React.useRef(null);
  var inputRef = React.useRef(null);
  var buttonRef = React.useRef(null);
  var overlayRef = React.useRef(null);
  var _useLocalization = useLocalization(),
    t = _useLocalization.t;
  useEffect(function () {
    defaultValue !== '' && setSearchValue(defaultValue);
  }, []);
  var eventHandler = function eventHandler(event) {
    var key = event.key,
      shiftKey = event.shiftKey;
    if (KEY_VALUES.TAB === key) {
      setKeyboardFocus(true);
      var activeElement = getActiveElement();
      shiftKey ? preFocusRef.current === undefined && showList && setShowList(false) : nextFocusRef.current === undefined && activeElement.className !== 'ap-field-input' && showList && setShowList(false);
    }
  };
  var keyupEvent = function keyupEvent(event) {
    var key = event.key;
    var element = getActiveElement();
    if (KEY_VALUES.TAB === key) {
      var _containerRef$current;
      setKeyboardFocus(true);
      nextFocusRef.current = getNextFocusableElement(containerRef.current, element);
      preFocusRef.current = getNextFocusableElement(containerRef.current, element, true);
      !((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(element)) && showList && setShowList(false);
    }
  };
  var getNextFocusableElement = function getNextFocusableElement(findElement, element, isPre) {
    if (isPre === void 0) {
      isPre = false;
    }
    var controls = "button:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n    [href][clientHeight][clientWidth]:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n    input:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n    select:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n    textarea:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n    [tabIndex]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n    [contenteditable]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])";
    var focusable = findElement === null || findElement === void 0 ? void 0 : findElement.querySelectorAll(controls); //(containerRef.current! as HTMLElement)?
    var index = Array.prototype.indexOf.call(Array.from(focusable), element);
    return Array.from(focusable)[isPre ? index - 1 : index + 1];
  };
  useEffect(function () {
    var eventClickHandler = function eventClickHandler() {
      setKeyboardFocus(false);
    };
    window.addEventListener('click', eventClickHandler);
    return function () {
      window.removeEventListener('click', eventClickHandler);
    };
  });
  items = React.useMemo(function () {
    if ('data' in props) {
      var datalist = transformData(data, categoryKey);
      items = (datalist === null || datalist === void 0 ? void 0 : datalist.filter(shouldDisplay(searchBy, searchValue, searchValue !== '' ? '' : value, labelKey, categoryKey))) || [];
      if (items.length > 0) {
        setShowBlank(false);
      } else {
        setShowBlank(true);
      }
      return items;
    }
    return [];
  }, [data, searchValue, value, labelKey, showHistory]);
  var getHistories = function getHistories() {
    var historiesString = localStorage.getItem(LocalStorageKey);
    var histoies = [];
    if (historiesString) {
      histoies = JSON.parse(historiesString);
    }
    return histoies;
  };
  var _useFocusItemValue = useFocusItemValue(value, {
      items: showHistory ? getHistories() : items,
      valueKey: valueKey
    }),
    focusItemValue = _useFocusItemValue.focusItemValue,
    setFocusItemValue = _useFocusItemValue.setFocusItemValue,
    handleKeyDown = _useFocusItemValue.onKeyDown;
  var handleKeyDownEvent = function handleKeyDownEvent(event) {
    onMenuKeyDown(event, {
      enter: handleEnter,
      esc: function esc() {
        return handleClose(event, true);
      }
    }, function () {
      inputRef.current.focus();
    }, eventHandler);
    handleKeyDown(event);
  };
  useEffect(function () {
    if (showHistory) {
      renderSearchHistory();
    }
  }, [showHistory, focusItemValue]);
  useEffect(function () {
    if (!showList) {
      nextFocusRef.current = null;
      preFocusRef.current = null;
    }
  }, [showList]);
  var handleEnter = function handleEnter(event) {
    var buttonEle = buttonRef.current;
    if (event.key === KEY_VALUES.SPACE) {
      focusItemValue !== '' && event.preventDefault();
    }
    if (searchType === 'primary') {
      if (event.key === KEY_VALUES.SPACE && !buttonEle.contains(event.target)) {
        return;
      }
      handlePrimarySearch(event);
      return;
    } else if (searchType === 'secondary' && !('data' in props)) {
      if (buttonEle.contains(event.target)) {
        handleClean(event);
      }
      return;
    }
    if (buttonEle.contains(event.target)) {
      handleClean(event);
      return;
    } else {
      if (!(searchValue === '' && !showList)) setShowList(!showList);
    }
    if (!focusItemValue) {
      return;
    }
    var focusItem = showHistory ? getHistories().find(function (item) {
      return item[valueKey] === focusItemValue;
    }) : items.find(function (item) {
      return item[valueKey] === focusItemValue;
    });
    var searchValueTemp = focusItem === null || focusItem === void 0 ? void 0 : focusItem[labelKey];
    setSearchValue(searchValueTemp);
    setValue(searchValueTemp);
    setFocusItemValue('');
    handleSelect(focusItem === null || focusItem === void 0 ? void 0 : focusItem[valueKey], focusItem, event);
    saveHistory(focusItem);
    if (value !== searchValueTemp) {
      handleChangeValue(searchValueTemp, event);
    }
    if (searchValueTemp.length > 0) {
      setShowDeleteIcon(true);
    }
    handleClose();
  };
  var handleSelect = useCallback(function (value, item, event) {
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(value, item, event);
  }, [onSelect]);
  var handleClean = function handleClean(event) {
    (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current).focus();
    setValue('');
    setSearchValue('');
    setFocus(true);
    if ('data' in props) {
      setShowList(true);
      setShowBlank(true);
    }
    onClear === null || onClear === void 0 ? void 0 : onClear();
    onChange === null || onChange === void 0 ? void 0 : onChange('', event);
  };
  var handleChangeValue = useCallback(function (value, event) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value, event);
  }, [onChange]);
  var handleInputKeyDown = function handleInputKeyDown(event) {
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
  };
  var handleInputChange = function handleInputChange(event) {
    var _event$target;
    var value = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value;
    if (value.length > 0) {
      switch (searchType) {
        case 'primary':
          setShowPressIcon(true);
          break;
        case 'secondary':
          setShowDeleteIcon(true);
          if ('data' in props) {
            setShowList(true);
            setShowHistory(false);
            if (items.length > 0) {
              setShowBlank(false);
            } else {
              setShowBlank(true);
            }
          }
          break;
      }
    } else {
      switch (searchType) {
        case 'primary':
          setShowPressIcon(false);
          break;
        case 'secondary':
          setShowHistory(false);
          setShowDeleteIcon(true);
          if ('data' in props) {
            setShowList(true);
            setShowBlank(true);
          }
          break;
      }
    }
    setFocusItemValue('');
    setFocus(true);
    setSearchValue(value);
    setValue('');
    onChange === null || onChange === void 0 ? void 0 : onChange(value, event);
  };
  var handleClose = function handleClose(event, shouldClear) {
    if (shouldClear === void 0) {
      shouldClear = false;
    }
    if (showList) {
      setShowList(false);
      if (shouldClear) {
        setSearchValue('');
        setValue('');
        isControlled && (onClear === null || onClear === void 0 ? void 0 : onClear());
      }
      onClose === null || onClose === void 0 ? void 0 : onClose();
    } else {
      shouldClear && setSearchValue('');
      shouldClear && setValue('');
      isControlled && (onClear === null || onClear === void 0 ? void 0 : onClear());
      isControlled && (onChange === null || onChange === void 0 ? void 0 : onChange('', event));
    }
  };
  var handleOpen = useCallback(function () {
    setFocus(true);
    onOpen === null || onOpen === void 0 ? void 0 : onOpen();
  }, [onOpen]);
  var handleItemSelect = useCallback(function (value, item, event) {
    var nextItemValue = item[labelKey];
    setSearchValue(nextItemValue);
    setValue(nextItemValue);
    setFocusItemValue('');
    handleSelect(value, item, event);
    saveHistory(item);
    if (value !== nextItemValue) {
      handleChangeValue(nextItemValue, event);
    }
    handleClose(event);
  }, [value, setValue, handleSelect, handleChangeValue, handleClose, setFocusItemValue]);
  var handleInputFocus = useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
    var value = event.target.value;
    switch (searchType) {
      case 'primary':
        if (value.length > 0) {
          setShowPressIcon(true);
        }
        break;
      case 'secondary':
        setShowDeleteIcon(true);
        if (value.length > 0) {
          if ('data' in props) {
            setShowList(true);
          }
        } else {
          if (props.showHistory) {
            var histories = getHistories();
            if (histories.length > 0) {
              setShowList(true);
              setShowBlank(false);
              setShowHistory(true);
              renderSearchHistory();
            }
          } else {
            setShowHistory(false);
          }
        }
        break;
    }
    setFocus(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
  }, [onFocus, handleOpen]);
  var handleInputBlur = useCallback(function (event) {
    var value = event.target.value;
    switch (searchType) {
      case 'primary':
        if (value.length > 0) {
          setActiveSearch(true);
        } else {
          setActiveSearch(false);
        }
        break;
      case 'secondary':
        if (value.length > 0) {
          setShowDeleteIcon(true);
          setActiveSearch(true);
        } else {
          setShowDeleteIcon(false);
          setActiveSearch(false);
        }
    }
    setFocus(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
  }, [onBlur]);
  var handlePrimarySearch = function handlePrimarySearch(event) {
    setShowPressIcon(false);
    if (searchValue.length > 0) {
      setActiveSearch(true);
    }
    onSearch === null || onSearch === void 0 ? void 0 : onSearch(searchValue, event);
    if (buttonRef.current) {
      buttonRef.current.blur();
    }
    if (inputRef.current) {
      inputRef.current.blur();
    }
    setKeyboardFocus(false);
  };
  var hideOnClickOutside = function hideOnClickOutside(event) {
    handleClose(event);
    inputRef.current.blur();
  };
  useClickOutside({
    enabled: true,
    isOutside: function isOutside(event) {
      var _containerRef$current2;
      var eventSource = getEventSource(event);
      return !((_containerRef$current2 = containerRef.current) !== null && _containerRef$current2 !== void 0 && _containerRef$current2.contains(eventSource));
    },
    handle: showList ? hideOnClickOutside : function () {
      return null;
    }
  });
  var saveHistory = function saveHistory(item) {
    if (searchType === 'secondary' && 'data' in props && props.showHistory) {
      var historiesString = localStorage.getItem(LocalStorageKey);
      var _histoies = [];
      if (historiesString) {
        _histoies = JSON.parse(historiesString);
        if (_histoies.length === limitHistory) _histoies.pop();
        var index = _histoies.findIndex(function (history) {
          return history[valueKey] === item[valueKey];
        });
        if (index > -1) {
          return;
        } else {
          _histoies.unshift(item);
        }
      } else {
        _histoies = [item];
      }
      localStorage.setItem(LocalStorageKey, JSON.stringify(_histoies));
      onHistoryChange === null || onHistoryChange === void 0 ? void 0 : onHistoryChange(_histoies);
    }
  };
  var searchTypeNode = function searchTypeNode() {
    var classes = classNames('ap-search-after-icon', {
      'delete-icon': searchType === 'secondary',
      'enter-icon': searchType === 'primary',
      showPressIcon: showPressIcon,
      showDeleteIcon: showDeleteIcon,
      active: searchType === 'secondary' && searchValue.length > 0
    });
    var iconClassed = classNames('Appkit4-icon', {
      'icon-return-outline': searchType === 'primary',
      'icon-circle-delete-outline': searchType === 'secondary'
    });
    var searchTypeProps = {
      ref: buttonRef,
      role: 'button',
      'aria-disabled': searchValue === '',
      tabIndex: disabled || searchType === 'primary' && !showPressIcon || searchType === 'secondary' && searchValue.length === 0 ? -1 : 0,
      'aria-hidden': !showPressIcon,
      'aria-label': ariaLabel || searchType === 'primary' ? t('search') : t('clear'),
      className: classes,
      onClick: searchType === 'primary' ? handlePrimarySearch : searchValue.length === 0 ? function () {} : handleClean
    };
    if (searchType !== 'primary') delete searchTypeProps['aria-hidden'];
    return /*#__PURE__*/React.createElement("span", searchTypeProps, /*#__PURE__*/React.createElement("i", {
      className: iconClassed,
      "aria-hidden": true
    }));
  };
  var containerClasses = classNames('ap-search-container', className, {
    show: searchType !== 'primary' && showList
  });
  var renderSearchHistory = function renderSearchHistory() {
    var historiesString = localStorage.getItem(LocalStorageKey);
    var tmp;
    if (historiesString) {
      var histories = JSON.parse(historiesString);
      if (histories.length === 0) {
        setShowHistory(true);
        inputRef.current.focus();
        tmp = /*#__PURE__*/React.createElement("div", {
          className: "ap-option-item noResult"
        }, /*#__PURE__*/React.createElement("span", {
          className: "ap-option-label"
        }, noHistoryMsg || t('noHistoryMessage')));
        setNodes(tmp);
        return;
      }
      tmp = [];
      var _loop = function _loop(index) {
        var item = histories[index];
        var newLi = /*#__PURE__*/React.createElement("div", {
          key: index,
          className: classNames('ap-option-item', {
            moved: item[valueKey] === focusItemValue
          }),
          role: "searchbox",
          "aria-label": item[labelKey],
          tabIndex: -1,
          onClick: function onClick(event) {
            return handleItemSelect(item[valueKey], item, event);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "ap-option-left"
        }, /*#__PURE__*/React.createElement("label", {
          className: "ap-option-label"
        }, item[labelKey])), /*#__PURE__*/React.createElement("span", {
          role: "button",
          "aria-label": t('clear'),
          className: "recent-delete-icon",
          onClick: function onClick(event) {
            event.stopPropagation();
            histories.splice(index, 1);
            localStorage.setItem(LocalStorageKey, JSON.stringify(histories));
            renderSearchHistory();
            onHistoryChange === null || onHistoryChange === void 0 ? void 0 : onHistoryChange(histories);
          },
          tabIndex: 0,
          onKeyDown: function onKeyDown(event) {
            event.stopPropagation();
            var key = event.key;
            if (key === KEY_VALUES.ENTER || key === KEY_VALUES.SPACE) {
              histories.splice(index, 1);
              localStorage.setItem(LocalStorageKey, JSON.stringify(histories));
              renderSearchHistory();
              onHistoryChange === null || onHistoryChange === void 0 ? void 0 : onHistoryChange(histories);
            } else if (KEY_VALUES.TAB === key) {
              if (nextFocusRef.current === undefined || preFocusRef.current === null) {
                var activeElement = getActiveElement();
                !getNextFocusableElement(document, activeElement) && event.preventDefault();
                setShowList(false);
              }
            }
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "Appkit4-icon icon-close-outline"
        })));
        tmp.push(newLi);
      };
      for (var index = 0; index < histories.length; index++) {
        _loop(index);
      }
      setNodes(tmp);
    }
  };
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    className: containerClasses,
    ref: mergeRefs(ref, containerRef),
    onKeyUp: keyupEvent
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    className: "search-result",
    "aria-live": "assertive",
    "aria-atomic": "true"
  }, ((_items = items) === null || _items === void 0 ? void 0 : _items.length) > 0 ? (_resultMessage = t('aria').resultMessage) === null || _resultMessage === void 0 ? void 0 : _resultMessage.replace('{0}', String(items.filter(function (item) {
    return !item.disabled;
  }).length)) : noResultFound || t('noResultMessage')), /*#__PURE__*/React.createElement("div", {
    className: classNames('ap-search-input', {
      disabled: disabled,
      focus: focus,
      'keyboard-focus': keyboardFocus
    }),
    onKeyDown: handleKeyDownEvent
  }, /*#__PURE__*/React.createElement("input", _extends({
    ref: inputRef,
    type: "text",
    role: "searchbox",
    tabIndex: 0,
    value: searchValue,
    placeholder: placeholder || t('search'),
    autoComplete: "off",
    "aria-disabled": disabled,
    "aria-label": ariaLabel,
    "aria-activedescendant": focusItemValue ? focusItemValue : null,
    disabled: disabled,
    onKeyDown: handleInputKeyDown,
    onFocus: handleInputFocus,
    onBlur: handleInputBlur,
    onChange: handleInputChange
  }, inputProps, {
    className: classNames('ap-field-input', inputProps === null || inputProps === void 0 ? void 0 : inputProps.className, {
      error: error
    })
  })), /*#__PURE__*/React.createElement("i", {
    className: classNames('Appkit4-icon icon-search-outline', {
      activeSearch: activeSearch
    }),
    "aria-hidden": true
  }), searchTypeNode()), showList && searchType !== 'primary' && /*#__PURE__*/React.createElement("div", {
    className: "ap-search-list",
    ref: overlayRef,
    role: "listbox",
    "aria-label": "Option List"
  }, showList && function () {
    var _items2;
    var key = '';
    var showCate = false;
    return (_items2 = items) === null || _items2 === void 0 ? void 0 : _items2.map(function (item, index) {
      if (item[categoryKey] && key !== item[categoryKey]) {
        key = item[categoryKey];
        showCate = true;
      } else {
        showCate = false;
      }
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, showCate && /*#__PURE__*/React.createElement("div", {
        key: item[categoryKey],
        className: "ap-option-group"
      }, /*#__PURE__*/React.createElement("span", {
        className: "ap-group-label"
      }, item[categoryKey])), /*#__PURE__*/React.createElement(DropdownMenuItem, {
        role: "option",
        disabled: item.disabled,
        active: item[valueKey] === value,
        focus: focusItemValue === item[valueKey],
        onSelect: handleItemSelect,
        data: item,
        value: item[valueKey],
        label: item[labelKey],
        highlightWords: searchValue,
        showIncreaseArrow: true
      }));
    });
  }(), showList && showBlank && items.length === 0 && !showHistory && /*#__PURE__*/React.createElement("div", {
    className: "ap-option-item noResult",
    role: "option"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ap-option-label"
  }, noResultFound || t('noResultMessage'))), showHistory && nodes)));
});
Search.displayName = 'Search';
export default Search;